module.exports = __webpack_public_path__ + "static/media/follower_2.1ebf8662.png";